import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { navigate } from 'vendor/react-big-calendar/utils/constants';
import "./Toolbar.scss";

class ClasstopToolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(
      PropTypes.string,
    ).isRequired,
    label: PropTypes.node.isRequired,
    messages: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onViewChange: PropTypes.func.isRequired,
  }

	constructor(props) {
		super(props);
	}

  render() {
    let { messages, label } = this.props;

    return (
      <div className='rbc-toolbar'>
				<div className='toolbar-top-section'>
					<span className='selecting-view'>
						{
							this.viewNamesGroup(messages)
						}
					</span>
					<div className='rbc-toolbar-label date-label'>
						{ label }
					</div>
				</div>
				<div className='toolbar-bottom-section'>
					<span className='navigate-date'>
						<div
							className='change-date-button btn-link'
							onClick={this.navigate.bind(null, navigate.PREVIOUS)}
						>
							<i className='change-date-arrow fa icon-left-dir'></i>
							{__("Previous Week", "schedule.calendar")}
						</div>
						<div
							className='change-date-button btn-link'
							onClick={this.navigate.bind(null, navigate.TODAY)}
						>
							{__("Today", "schedule.calendar")}
						</div>
						<div
							className='change-date-button btn-link'
							onClick={this.navigate.bind(null, navigate.NEXT)}
						>
							{__("Next Week", "schedule.calendar")}
							<i className='change-date-arrow fa icon-right-dir'></i>
						</div>
					</span>
				</div>
      </div>
    );
  }

  navigate = (action) => {
    this.props.onNavigate(action)
  }

  view = (view) => {
    this.props.onViewChange(view)
  }

  viewNamesGroup(messages) {
    let viewNames = this.props.views
    const view = this.props.view

    if (viewNames.length > 1) {
      return (
        viewNames.map(name =>
          <div key={name}
            className={cn('tab-select-button', {'rbc-active': view === name})}
            onClick={this.view.bind(null, name)}
          >
            {__(messages[name], "schedule.calendar")}
          </div>
        )
      )
    }
  }
}

export default ClasstopToolbar;



// WEBPACK FOOTER //
// ./src/components/classtop-react-big-calendar/Toolbar.js